export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27')
];

export const server_loads = [];

export const dictionary = {
		"/": [2],
		"/blog": [3],
		"/blog/[slug]": [4],
		"/companies": [5],
		"/companies/[id]": [6],
		"/contact": [7],
		"/drop-cv": [8],
		"/drop-jd": [9],
		"/faq": [10],
		"/hire-backend-developers": [12],
		"/hire-data-engineers": [13],
		"/hire-devops-engineers": [14],
		"/hire-frontend-developers": [15],
		"/hire-full-stack-developers": [16],
		"/hire-mobile-developers": [17],
		"/hire-qa-tester": [18],
		"/hire": [11],
		"/how-it-works": [19],
		"/jobs/[[role]]": [22],
		"/job/[id]": [21],
		"/j/[id]": [20],
		"/preferences/[token]": [23],
		"/pricing": [24],
		"/privacy": [25],
		"/talent-profile-vs-traditional-ats": [26],
		"/terms": [27]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';